import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { Router  } from '@angular/router';
import { SharedService } from '../../_service/shared.service';
import { LeadsService } from '../../_service/leads.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroupDirective, FormBuilder, FormGroup, NgForm, Validators, FormArray } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-update-insurance-modal',
  templateUrl: './update-insurance-modal.component.html',
  styleUrls: ['./update-insurance-modal.component.css']
})
export class UpdateInsuranceModalComponent implements OnInit {
    insuranceForm: FormGroup;loading:boolean=false;submitted:boolean=false;lead={lead_name:'',mobile:''};dataLoaded:boolean=false;fileDeleting:boolean = false;
    allUploads=[];allPreauthUploads=[];s3url='';doc_type:string;uploading:boolean=false;myrole:string;hospitals=[];disableSelect:any = [];hospitals_copy=[];hos_lead_id='';hos_insurance_id='';var_circle_id:any='';insurance_company=[];insurance_company_copy=[];preauth_hospital_name='';
    preauth_arrival_time='';preauth_doctor_id='';circles=[];circles_copy=[];treatments=[];treatments_copy=[];

    placements = ['left'];
    popoverTitle = 'Are you sure?';
    popoverMessage = 'Are you really <b>sure</b> you want to do this?';
    confirmText = 'Yes <i class="fas fa-check"></i>';
    cancelText = 'No <i class="fas fa-times"></i>';
    confirmClicked = false;
    cancelClicked = false;

    constructor(public dialogRef: MatDialogRef<UpdateInsuranceModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog,
    private router:Router,private sharedapi:SharedService, private leadapi:LeadsService,private formBuilder: FormBuilder) 
    {
        this.insuranceForm = this.formBuilder.group({ 
            'policy_number' : [null, [Validators.required, Validators.minLength(10)]],
            'insurance_company' : [null, Validators.required],
            'employee_id' : [null],
            'circle_id':[null, Validators.required],
            'treatment_id':[null, Validators.required],
            'corporate' : [null],
            'room' : [null,Validators.required],
            'tpa' : [null,Validators.required],
            'sum_insured' : [null,Validators.required],
            'balance_sum_insured' : [null],
            'room_rent' : [null,Validators.required],
            'copay' : ['null',Validators.required],
            'description' : [null],
            'status' : [0],
            'claim_number' : [null],
            'approval_number' : [null],
            'recovery_remark' : [null],
            'queries' : [null],
            'policy_expiry' : [null],
            'policy_start_on' : [null],
            'policy_expiry_on' : [null],
            'disease_capping': [null],
            'disease_capping_amount': [null],
            'preexisting_disease_option': [null],
            'preexisting_disease': [null],
            'waiting_period_option': [null],
            'waiting_period': [null],
            'portability_details_from': [null],
            'portability_details_current': [null],
            'day_care_option': [null],
            'hospitalAmtResources': this.formBuilder.array([]) ,
        });
        /* this.getHospital(); */
        this.getInsuranceCompany();
    }
    
    ngOnInit(): void {
        this.sharedapi.getRole()
        this.sharedapi.getRole().subscribe((item:string) => {this.myrole=item;});
        this.myrole = localStorage.getItem('role');
        this.getInsuranceDetails();
        this.s3url = localStorage.getItem('s3url');
        this.getcircle();this.getTreatment();
    }

    searchOnSelect(searchtText: string, type){
        if (type == 'circle') {
            this.circles = this.sharedapi.searchData(searchtText, this.circles_copy, "name");
        } else if(type == 'treatment'){
            this.treatments = this.sharedapi.searchData(searchtText, this.treatments_copy, "name");
        }
    }

    setSearchValue(type){
        if(type=='circle'){
            $("#circleSearch").val('');
            $("#circleSearch").focus();
            this.circles= this.circles_copy;
        } else if(type=='treatment'){
            $("#treatmentSearch").val('');
            $("#treatmentSearch").focus();
            this.treatments= this.treatments_copy;
        }
    }

    getCircleHospitals(circ_id)
    {
        this.getHospital(circ_id)
    }

    async getcircle()
    {
        await this.leadapi.getcircles().subscribe((data:any) => {
            if(data.status)
            {
                this.circles = data.data;
                this.circles_copy = this.circles;
            }else{
                this.circles = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async updateInsurance()
    {        
        this.submitted = true;
        this.loading = true;
        // stop here if form is invalid
        if (this.insuranceForm.invalid) {
            this.loading = false;
            return;
        }
        await this.leadapi.updateInsurancDetails(this.data,this.insuranceForm.value)
        .subscribe((data:any) => {
            this.submitted = false;
            this.loading = false;
            if(data.status)
            {
                this.sharedapi.presentToast(data.msg);
                this.getInsuranceDetails()
            }
            else
            {
                this.sharedapi.presentToast(data.msg);
            }
          }, error => 
            {
                this.sharedapi.checkError(error);
            });
    }

    get f() { return this.insuranceForm.controls; }

    async selectFile(event)
    {
        if(this.doc_type!=undefined)
        {
            this.uploading = true;
            let file = event.target.files.item(0);
            const formData = new FormData();  
            formData.append('upload_type', this.doc_type); 
            formData.append('file', file); 
            await this.leadapi.uploadInsuranceFile(this.data,formData)
            .subscribe((data:any) => {
                this.uploading = false;
                if(data.status)
                {
                    this.sharedapi.presentToast('File uploaded Successful');
                    this.getInsuranceDetails();
                }
                else
                {
                    this.sharedapi.presentToast(data.msg);
                }
              }, error => 
                {
                    this.uploading = false
                    this.sharedapi.checkError(error);
                });
        }else{
            this.sharedapi.presentToast('Please select Document Type');
        }
    }

    getInsuranceDetails()
    {
        this.dataLoaded = false;
        
        this.leadapi.getInsuranceDetails(this.data).subscribe(
        (data:any) => {
            this.dataLoaded = true;
            if(data.lead)
            {
                this.lead = data.lead;
            }
            if(data && data.status)
            {
                this.preauth_hospital_name="";
                this.preauth_arrival_time="";
                this.preauth_doctor_id="";

                this.preauth_hospital_name=data.data.preauth_hospital_id;
                this.preauth_arrival_time=data.data.preauth_arrival_date_time;
                this.preauth_doctor_id=data.data.preauth_doctor_id;

                this.getPreauthInsuranceDetails();
                /* console.log(data); */

                this.allUploads = data.uploads;
                this.insuranceForm.controls['policy_number'].setValue(data.data.policy_number);
                this.insuranceForm.controls['insurance_company'].setValue(data.data.insurance_company);
                this.insuranceForm.controls['employee_id'].setValue(data.data.employee_id);
                this.insuranceForm.controls['corporate'].setValue(data.data.corporate);
                this.insuranceForm.controls['tpa'].setValue(data.data.tpa);
                this.insuranceForm.controls['circle_id'].setValue(data.lead.circle_id);  
                this.insuranceForm.controls['treatment_id'].setValue(data.lead.treatment_id); 
                this.insuranceForm.controls['sum_insured'].setValue(data.data.sum_insured);
                this.insuranceForm.controls['balance_sum_insured'].setValue(data.data.balance_sum_insured);
                this.insuranceForm.controls['room_rent'].setValue(data.data.room_rent);
                this.insuranceForm.controls['copay'].setValue(data.data.copay ? parseInt(data.data.copay) : 1);
                this.insuranceForm.controls['description'].setValue(data.data.description);
                this.insuranceForm.controls['room'].setValue(data.data.room);

                this.insuranceForm.controls['claim_number'].setValue(data.data.claim_number);
                this.insuranceForm.controls['approval_number'].setValue(data.data.approval_number);
                this.insuranceForm.controls['recovery_remark'].setValue(data.data.recovery_remark);
                this.insuranceForm.controls['queries'].setValue(data.data.queries);
                this.insuranceForm.controls['status'].setValue(data.data.status);
                this.insuranceForm.controls['policy_expiry'].setValue(data.data.policy_expiry);
                this.insuranceForm.controls['policy_expiry_on'].setValue(data.data.policy_expiry_on ? new Date(data.data.policy_expiry_on*1000) : '');
                this.insuranceForm.controls['policy_start_on'].setValue(data.data.policy_start_on ? new Date(data.data.policy_start_on*1000) : '');
                this.insuranceForm.controls['disease_capping'].setValue(data.data.disease_capping);
                this.insuranceForm.controls['disease_capping_amount'].setValue(data.data.disease_capping_amount);
                this.insuranceForm.controls['preexisting_disease_option'].setValue(data.data.preexisting_disease_option);
                this.insuranceForm.controls['preexisting_disease'].setValue(data.data.preexisting_disease);
                this.insuranceForm.controls['waiting_period_option'].setValue(data.data.waiting_period_option);
                this.insuranceForm.controls['waiting_period'].setValue(data.data.waiting_period);
                this.insuranceForm.controls['portability_details_from'].setValue(data.data.portability_details_from);
                this.insuranceForm.controls['portability_details_current'].setValue(data.data.portability_details_current);
                this.insuranceForm.controls['day_care_option'].setValue(data.data.day_care_option);

                this.hos_lead_id = data.data.lead_id;
                this.hos_insurance_id = data.data.id;
                this.var_circle_id = data.lead.circle_id;
                
                this.getHospital(data.lead.circle_id);
                this.fetchHospitalAmountData();
            }else{
                if(data.error_type!='no')
                this.sharedapi.presentToast('Error Occured');
            }
        },
        error => {
            this.sharedapi.checkError(error);
        });
    }

    getPreauthInsuranceDetails()
    {

      this.dataLoaded = false;
      this.leadapi.getPreAuthInsuranceDetails(this.data,'1').subscribe(
      (data:any) => {
          this.dataLoaded = true;
          if(data.lead)
          {
              this.lead = data.lead;
          }
          if(data && data.status)
          {
              this.allPreauthUploads = data.uploads;
          }
      },
      error => {
          this.sharedapi.checkError(error);
      });
    }

    CloseModal(): void {
        this.dialogRef.close();
    }

    removeFileInsurance(fileId)
    {
        this.fileDeleting = true;
        this.leadapi.deleteInsuranceFiles(fileId).subscribe((data:any) => {
            this.fileDeleting = false;
            if(data.status)
            {
                this.getPreauthInsuranceDetails();
                this.getInsuranceDetails();
            }else{
                this.sharedapi.presentToast(data.msg);
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

  

    async getHospital(circle_id)
    {
        this.leadapi.gethospitalCircleWiseListing(circle_id).subscribe((data:any) => {
            if(data.status)
            {
                this.hospitals = data.data;
                this.hospitals_copy= this.hospitals;
            }else{
                this.hospitals = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    async getInsuranceCompany()
    {
        this.leadapi.getInsuranceCompanyList().subscribe((data:any) => {
            if(data.status)
            {
                this.insurance_company = data.data;
                this.insurance_company_copy= this.insurance_company;
            }else{
                this.insurance_company = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    hospitalAmtResources() : FormArray {
        return this.insuranceForm.get("hospitalAmtResources") as FormArray
    }
      
    addMoreHospitalAmount() {
        this.hospitalAmtResources().push(this.newQuantity());
        let getIndex= this.insuranceForm.controls["hospitalAmtResources"].value.length-1;
        this.disableSelect[getIndex]=true;
    }
  
    newQuantity(): FormGroup 
    {
        return this.formBuilder.group({
            hospital_id: '',
            payment_mode_option: '',
            hospital_amount: '',
            hospitalAmountId: ''
        })
    }

    removeQuantity(i:number, hospital_amount_id) {
        this.hospitalAmtResources().removeAt(i);

        if(hospital_amount_id) {
            this.leadapi.hospitalAmountDeleted(hospital_amount_id).subscribe((data:any) => {
                if(data.status) {
                    this.getInsuranceDetails();
                } else {
                    this.sharedapi.checkError(data.msg);
                }
        }, error => {
            this.sharedapi.checkError(error);
        });
        } else {
            this.hospitalAmtResources().removeAt(i);
        }
    }

    async fetchHospitalAmountData()
    {
        this.leadapi.fetchHospitalAmountData(this.hos_lead_id, this.hos_insurance_id).subscribe((data:any) => {
            if(data.status)
            {
                let controlArray = this.insuranceForm.get('hospitalAmtResources') as FormArray;
                controlArray.clear();
                data.data.forEach((element, index) => {
                    controlArray.push(this.formBuilder.group({
                        hospital_id: element.hospital_id,
                        payment_mode_option: element.payment_mode_option,
                        hospital_amount: element.amount,
                        hospitalAmountId :element.id
                    }));
                });
            }
        });
        
    }

    async getTreatment()
    {
        await this.leadapi.getTreatments().subscribe((data:any) => {
            if(data.status)
            {
                this.treatments = data.data;
                this.treatments_copy= this.treatments;
            }else{
                this.treatments = [];
            }
        }, error => {
            this.sharedapi.checkError(error);
        });
    }

    
}
